module.exports = __webpack_public_path__ + "media/images/icons/heart-20ea40c629128c108fb6723c9da76bbd.svg";